import { Service } from './../models/service.model';
import { ProductType } from './../models/product.model';
import { AuthService } from './auth.service';
import { Quote } from './../models/quote.model';
import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { UtilsService } from './utils.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
  providedIn: 'root'
})
export class QuotesService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
        private authService: AuthService
    ) { }

    getQuotes(page: number, itemsPerPage: number, sorts: SortConfiguration[], filters: any = {}) {
        const url = '/cotizaciones';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params: any = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        const serialized = JSON.parse(JSON.stringify(filters));
        Object.entries(serialized).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                params[key] = value;
            }
        });
        const user = this.authService.getUser();
        if (user?.tipo === 'AGENTE') {
            params['id-agente'] = user.agente?.id;
        } else if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        return this.http.get<Quote[]>(url, { headers, observe: 'response', params });
    }

    deleteQuote(quoteId: ID) {
        return this.http.delete(`/cotizaciones/${quoteId}`);
    }

    getQuoteById(id: ID) {
        return this.http.get<Quote>(`/cotizaciones/${id}`);
    }

    newQuote(quote: Quote) {
        return this.http.post<Quote>(`/cotizaciones`, quote);
    }

    fastQuote(params: {
        tipo: string, alquiler: number, codigoMonedaAlquiler?: string, expensas: number, codigoMonedaExpensas?: string,
        tipoCambio?: number, actualizacion?: number, periodoActualizacion?: number, duracion: number, servicios: Service[],
        tipoProducto: ProductType, idOficina: ID, idAgente?: ID, idComercial?: number, descuentoComercial?: number,
        nombre?: string, apellido?: string, dniCuit?: string, perfilAprobado?: boolean, incluir12Cuotas?: boolean
    }) {
        return this.http.post<Quote>(`/cotizaciones/rapida`, params);
    }

    sendByEmail(id: ID, destinatario: string) {
        return this.http.post(`/cotizaciones/${id}/email`, { destinatario });
    }

    downloadPdf(id: ID) {
        return this.http.get(`/cotizaciones/${id}/pdf`, { responseType: 'blob', observe: 'response' });
    }
}
